<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [styleClass]="'backdrop-blur-sm'"
  [draggable]="false"
  [resizable]="false"
  [closable]="false"
  [closeOnEscape]="false"
  [dismissableMask]="true"
  (onHide)="hideDialog()"
  [style]="{ width: '90vw', maxWidth: '600px',border: 'none', background: 'none' }"
>
  <div class="relative w-full sticky-header">
    <div class="absolute right-6 top-6">
      <button
        class="w-4 h-4 flex items-center justify-center text-[#464255]"
        (click)="hideDialog()"
      >
        <img src="assets/icons/close.svg" alt="Close" class="w-full h-full">
      </button>
    </div>
    <div class="text-left">
      <h2 class="text-2xl font-semibold text-[#464255] mb-1">
        Change Plan?
      </h2>
      <p class="text-base text-[#464255] opacity-80">
        Please confirm your plan change
      </p>
    </div>
  </div>

  <div class="flex flex-col items-center justify-center text-center py-6 px-4">
    <div class="w-full mb-6">
      <!-- Current Plan Section -->
      <div class="bg-white rounded-lg p-4 mb-4 border border-gray-200">
        <div class="text-sm text-gray-600 mb-2">Current Plan</div>
        <div class="text-lg font-semibold text-[#464255]">{{ getCurrentPlanInterval() }}</div>
        <div class="text-2xl font-bold text-[#AB54DB]">{{ getCurrentPlanPrice() }}/month</div>
      </div>
      
      <div class="flex items-center justify-center mb-4">
        <div class="w-8 h-8 bg-[#AB54DB] rounded-full flex items-center justify-center">
          <svg class="w-4 h-4 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 14l-7 7m0 0l-7-7m7 7V3"></path>
          </svg>
        </div>
      </div>
      
      <div class="bg-gradient-to-r from-[#AB54DB] to-[#EF9A91] rounded-lg p-4 border border-[#AB54DB]">
        <div class="text-sm text-white mb-2">New Plan</div>
        <div class="text-lg font-semibold text-white">{{ getNewPlanInterval() }}</div>
        <div class="text-2xl font-bold text-white">{{ getNewPlanPrice() }}/month</div>
      </div>
    </div>

    <div class="text-sm text-gray-600 mb-6 max-w-sm">
      Your plan will be updated immediately. Any changes will be reflected in your next billing cycle.
    </div>

    <div class="flex flex-col md:flex-row gap-3 w-full">
      <button
        type="button"
        class="flex-1 bg-gray-400 hover:bg-gray-500 text-white rounded-lg py-3 px-4 text-base font-medium transition-colors"
        [disabled]="loading"
        [class.opacity-50]="loading"
        [class.cursor-not-allowed]="loading"
        (click)="hideDialog()"
      >
        Cancel
      </button>
      <button
        type="button"
        class="flex-1 bg-[#AB54DB] hover:bg-opacity-90 text-white rounded-lg py-3 px-4 text-base font-medium transition-colors flex items-center justify-center gap-2"
        [disabled]="loading"
        [class.opacity-50]="loading"
        [class.cursor-not-allowed]="loading"
        (click)="onConfirm()"
      >
        <ng-container *ngIf="!loading">
          <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 6L9 17l-5-5"></path>
          </svg>
          Confirm Change
        </ng-container>
        <ng-container *ngIf="loading">
          <img src="assets/icons/spinner-icon.svg" alt="Loading" class="w-5 h-5 animate-spin" />
          Changing...
        </ng-container>
      </button>
    </div>
  </div>
</p-dialog> 